module.exports = "/static/Images/pt-br/VerySatisfied.png";